import React from 'react'
import { Select } from "antd"
import { Toggle as AntSwitch } from '../../../../../../../styleguide';

const VendorsPlacement = ({
  updateSetting,
  value,
  settingKey,
}) => {

  const handleHide = (checked) => {
    if (checked) {
      updateSetting(settingKey, []);
    } else {
      updateSetting(settingKey, ['underCategories']);
    }
  }

  return (
    <div className='vendors-placement'>
      <div className="hide-vendors-toggle">
        <div>
          <AntSwitch
            checked={!value.length}
            onChange={(checked) => handleHide(checked)}
          />
        </div>
        <p>Hide vendors from the message</p>
      </div>
      <div className="four-options">
        <h4>Display Vendors</h4>
        <Select
          style={{ width: '100%' }}
          value={value}
          onChange={(id) => updateSetting(settingKey, id)}
          mode="multiple"
        >
          <Select.Option
            key={'underCategories'}
            id={'underCategories'}
          >
            under privacy choices
          </Select.Option>
          <Select.Option
            key={'inTab'}
            id={'inTab'}
          >
            in a separate tab
          </Select.Option>
        </Select>
      </div>
    </div>
  )
}

export default VendorsPlacement;